export default "__VITE_ASSET__DxaO_Cuw__"